export type LegacyRuntimeSurface = 'browser' | 'virtual'

export interface LegacyBundleRuntime {
  sandboxGlobal?: unknown
  sandboxDom?: unknown
  hostGlobal?: unknown
  hostDom?: unknown
  virtual?: boolean
}

export function legacyRuntimeSurface(runtime: LegacyBundleRuntime | null | undefined): LegacyRuntimeSurface {
  return runtime?.virtual ? 'virtual' : 'browser'
}
